(() => {
  let opening = false;

  // Shopify injects its banner through content_for_header. Keep consent and
  // storage under Shopify's control; this control only reopens its preferences.
  const waitForBanner = () => {
    if (typeof window.privacyBanner?.showPreferences === 'function') {
      return Promise.resolve(window.privacyBanner);
    }
    return new Promise((resolve, reject) => {
      const script = document.querySelector('script[src*="/privacy-banner/storefront-banner.js"]');
      if (!script) {
        reject(new Error('Shopify cookie banner is unavailable'));
        return;
      }
      const finish = () => {
        window.clearTimeout(timer);
        script.removeEventListener('load', finish);
        script.removeEventListener('error', finish);
        if (typeof window.privacyBanner?.showPreferences === 'function') resolve(window.privacyBanner);
        else reject(new Error('Shopify cookie banner did not load'));
      };
      const timer = window.setTimeout(finish, 8000);
      script.addEventListener('load', finish);
      script.addEventListener('error', finish);
    });
  };

  // Delegation also supports footer replacements in the Shopify Theme Editor.
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest?.('[data-cookie-preferences]');
    if (!trigger || opening) return;
    const error = trigger.closest('.footer-cookie-preferences')?.querySelector('[data-cookie-preferences-error]');
    if (error) error.hidden = true;
    opening = true;
    trigger.setAttribute('aria-busy', 'true');
    trigger.setAttribute('aria-disabled', 'true');
    let timer;
    try {
      const banner = await waitForBanner();
      await Promise.race([
        banner.showPreferences(),
        new Promise((_, reject) => {
          timer = window.setTimeout(() => reject(new Error('Cookie preferences timed out')), 10000);
        })
      ]);
    } catch {
      if (error) error.hidden = false;
    } finally {
      window.clearTimeout(timer);
      trigger.removeAttribute('aria-busy');
      trigger.removeAttribute('aria-disabled');
      opening = false;
    }
  });
})();
